import { CALENDAR_JUNCTURES } from '../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CALENDAR_JUNCTURES.LOAD:
      return {
        ...state,
        loading: true,
      };
    case CALENDAR_JUNCTURES.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case CALENDAR_JUNCTURES.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
